import styles from "./DemoScreen.module.css";
import { Typography, InputLabel, Link } from "@material-ui/core";
import { exampleSpinOptions } from "../../config";
import { ExampleThumbnails } from "../../components/ExampleThumbnails/ExampleThumbnails";
import { Button } from "../../components/Button/Button";
import { loadUrl } from "../../redux";

export default function DemoScreen() {
  return (
    <div className={styles.gridContainer}>
      <div className={styles.logo}>
        <img
          src="https://sirv.sirv.com/website/img/sirv-logo.svg"
          alt="Sirv"
          width="50%"
          style={{ maxWidth: "120px", minWidth: "60px" }}
        />
      </div>
      <div className={styles.title}>
        <Typography variant="h2">360 Spin Hotspot Editor Demo</Typography>
      </div>
      <div className={styles.urlLabel} style={{ width: "100%" }}>
        <Typography variant="h3" style={{ marginBottom: "1rem" }}>
          Use this hotspot editor on your own spins! Request access from your
          Sirv account:
        </Typography>
        <Link
          href="https://my.sirv.com/#/contact"
          target="_blank"
          style={{ width: "100%" }}
        >
          <Button style={{ width: "100%" }}>Contact Sirv Team</Button>
        </Link>
      </div>
      <div className={styles.demoLabel}>
        <InputLabel>
          Or try placing hotspots on one of these example 360 spins
        </InputLabel>
      </div>
      <div
        style={{
          gridArea: "demo",
          display: "inline-flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: "20px",
        }}
      >
        <ExampleThumbnails
          // label="360 spin"
          items={exampleSpinOptions}
          itemClickHandler={loadUrl}
          style={{
            flex: "1",
          }}
        />
      </div>
    </div>
  );
}
